module.exports = __webpack_public_path__ + "img/estore_categories_frame.7dde7bce.svg";